var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.liClasses,staticStyle:{"width":"50px"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }